import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import themeResponsiveProperty from '../responsive/themeResponsiveProperty';

export default styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding-right: ${themeResponsiveProperty('.75rem', '1.75rem')};

  &:last-child {
    padding-right: 0;
  }
`;
